import Icon from '../Icon.vue'

Icon.register({
  'alert_smoke': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M5.782 8.703c-2.253.48-3.749 2.61-3.518 4.883a3.584 3.584 0 00-1.238.796A9.92 9.92 0 010 10C0 4.486 4.487 0 10.004 0c5.47 0 9.925 4.415 9.996 9.868a4.83 4.83 0 00-1.654-1.134c-.727-3.169-3.845-5.196-6.995-4.528C9.13 4.68 7.39 6.427 6.86 8.61a4.5 4.5 0 00-1.078.094v-.001zm11.521 1.594c1.108.302 1.958 1.157 2.201 2.298.017.08.05.143.083.259C18.354 16.98 14.527 20 10.004 20 6.8 20 3.95 18.48 2.118 16.132l.002-.007c0-.587.76-.884 1.398-1.03a.905.905 0 00.663-1.16 2.824 2.824 0 01-.062-.24c-.31-1.466.607-2.908 2.041-3.213a2.587 2.587 0 011.22.033.907.907 0 001.142-.811c.134-1.816 1.453-3.346 3.207-3.72 2.203-.464 4.378.979 4.859 3.218.022.11.04.22.053.326a.908.908 0 00.662.769z'
      }
    ]
  }
})
